import {
  createAsyncActions,
  runAsyncWorkflow
} from '../lib/reduxHelpers';
import { createActions } from "redux-actions";
import { Home } from '../api';

export const POPUP_OPENED = 'POPUP_OPENED'
export const BOOK_READ = 'BOOK_READ'
export const CATEGORY_CARD_OPENED = 'CATEGORY_CARD_OPENED'


export const [
  fetchHome,
  receiveHome,
  fetchHomeError
] = createAsyncActions(
  'HOME',
  () => {},
  ({ ok, data }) => ({ ok, data })
);

export const fetchHomeWorkflow = (perPage) => {
  const fetchPromise = Home.fetch(perPage);
  
  return runAsyncWorkflow({
    fetch: fetchHome,
    receive: receiveHome,
    error: fetchHomeError
  }, fetchPromise);
};

export const [
  fetchRecommendations,
  receiveRecommendations,
  fetchRecommendationsError
] = createAsyncActions(
  'RECOMMENDATIONS',
  () => {},
  ({ ok, data }) => ({ ok, data })
);

export const fetchRecommendationsWorkflow = (level,profile) => {
  const fetchPromise = Home.fetchRecommendations(level,profile);

  return runAsyncWorkflow({
    fetch: fetchRecommendations,
    receive: receiveRecommendations,
    error: fetchRecommendationsError
  }, fetchPromise)
};

export const [
  fetchCards,
  receiveCards,
  fetchCardsError
] = createAsyncActions(
  'CATEGORY',
  () => {},
  ({ data }) => ({  cards: data })
);

export const fetchCardsWorkflow = (stat) => {
  const fetchPromise = Home.fetchCards(stat);

  return runAsyncWorkflow({
    fetch: fetchCards,
    receive: receiveCards,
    error: fetchCardsError
  }, fetchPromise);
}

export const [
  fetchBannerImages,
  receiveBannerImages,
  fetchBannerImagesError
] = createAsyncActions(
  'BANNER_IMAGES',
  () => {},
  ({ data }) => ({  data })
);

export const fetchBannerImagesWorkflow = (profile) => {
  const fetchPromise = Home.fetchBannerImages(profile);

  return runAsyncWorkflow({
    fetch: fetchBannerImages,
    receive: receiveBannerImages,
    error: fetchBannerImagesError
  }, fetchPromise);
}

export const [
  fetchStoryNotice,
  receiveStoryNotice,
  fetchStoryNoticeError
] = createAsyncActions(
  'StoryNotice',
  () => {},
  () => {}
);

export const submitStoryNotice = () => {
  const fetchPromise = Home.updateSubmitStoryNotice();
  
  return runAsyncWorkflow({
    fetch: fetchStoryNotice,
    receive: receiveStoryNotice,
    error: fetchStoryNoticeError
  }, fetchPromise);
}

export const { popupOpened } = createActions('POPUP_OPENED');
export const { bookRead } = createActions('BOOK_READ');

export const [
  fetchSpotlightCards,
  receiveSpotlightCards,
  fetchSpotlightCardsError
] = createAsyncActions(
  'SPOTLIGHT_CARD',
  () => {},
  ({ ok, data }) => ({ ok, data })
);

export const fetchSpotlightCardsWorkflow = (profile, lang) => {
  const fetchPromise = Home.fetchSpotlightCards(profile, lang);
  
  return runAsyncWorkflow({
    fetch: fetchSpotlightCards,
    receive: receiveSpotlightCards,
    error: fetchSpotlightCardsError
  }, fetchPromise);
}

export const [
  fetchTrendingLanguages,
  receiveTrendingLanguages,
  fetchTrendingLanguagesError
] = createAsyncActions(
  'TRENDING_LANGUAGES',
  () => {},
  ({ ok, data }) => ({ ok, data })
);

export const fetchTrendingLanguagesWorkflow = () => {
  const fetchPromise = Home.fetchTrendingLanguages();
  
  return runAsyncWorkflow({
    fetch: fetchTrendingLanguages,
    receive: receiveTrendingLanguages,
    error: fetchTrendingLanguagesError
  }, fetchPromise);
}

export const [
  fetchTrendingStories,
  receiveTrendingStories,
  fetchTrendingStoriesError
] = createAsyncActions(
  'TRENDING_STORIES',
  () => {},
  ({ ok, data }) => ({ ok, data })
);

export const fetchTrendingStoriesWorkflow = (profile, level) => {
  const fetchPromise = Home.fetchTrendingStories(profile, level);
  
  return runAsyncWorkflow({
    fetch: fetchTrendingStories,
    receive: receiveTrendingStories,
    error: fetchTrendingStoriesError
  }, fetchPromise);
}

export const [
  fetchExplorations,
  receiveExplorations,
  fetchExplorationsError
] = createAsyncActions(
  'EXPLORATIONS',
  () => {},
  ({ ok, data }) => ({ ok, data })
);

export const fetchExplorationsWorkflow = (profile) => {
  const fetchPromise = Home.fetchExplorations(profile);

  return runAsyncWorkflow({
    fetch: fetchExplorations,
    receive: receiveExplorations,
    error: fetchExplorationsError
  }, fetchPromise)
}

export const [
  fetchTestimonials,
  receiveTestimonials,
  fetchTestimonialsError
] = createAsyncActions(
  'TESTIMONIALS',
  () => {},
  ({ ok, data }) => ({ ok, data })
);

export const fetchTestimonialsWorkflow = (profile) => {
  const fetchPromise = Home.fetchTestimonials(profile);

  return runAsyncWorkflow({
    fetch: fetchTestimonials,
    receive: receiveTestimonials,
    error: fetchTestimonialsError
  }, fetchPromise)
};

export const [
  fetchClassroomResource,
  receiveClassroomResource,
  fetchClassroomResourceError
] = createAsyncActions(
  'CLASSROOM_RESOURCE',
  () => {},
  ({ ok, classroom_resources }) => ({ ok, classroom_resources  })
);

export const fetchClassroomResourceWorkflow= () => {
  const fetchPromise = Home.fetchClassroomResources();

  return runAsyncWorkflow({
    fetch: fetchClassroomResource,
    receive: receiveClassroomResource,
    error: fetchClassroomResourceError
  }, fetchPromise)
};

export const [
  fetchEngagementContent,
  receiveEngagementContent,
  fetchEngagementContentError
] = createAsyncActions(
  'ENGAGEMENT_CONTENT',
  () => {},
  ({ ok, data, read_count }) => ({ ok, data, read_count })
);

export const fetchEngagementWorkFlow = () => {
  const fetchPromise = Home.fetchEngagementContent();

  return runAsyncWorkflow({
    fetch: fetchEngagementContent,
    receive: receiveEngagementContent,
    error: fetchEngagementContentError
  }, fetchPromise)
};

export const [
  fetchTrendingThemes,
  receiveTrendingThemes,
  fetchTrendingThemesError
] = createAsyncActions(
  'TRENDING_THEMES',
  ({ok}) => ({ok}),
  ({data}) => ({data })
);

export const fetchTrendingThemesWorkflow = () => {
  const fetchPromise = Home.fetchTrendingThemes();

  return runAsyncWorkflow(
    {
      fetch: fetchTrendingThemes,
      receive: receiveTrendingThemes,
      error: fetchTrendingThemesError
    },
    fetchPromise
  );
};

export const [
  fetchSeoData,
  receiveSeoData,
  fetchSeoDataError
] = createAsyncActions(
  'SEO_DATA',
  ({ok}) => ({ok}),
  ({seodata}) => ({seodata })
);

export const fetchSeoDataWorkflow = () => {
  const fetchPromise = Home.fetchSeoData();

  return runAsyncWorkflow(
    {
      fetch: fetchSeoData,
      receive: receiveSeoData,
      error: fetchSeoDataError
    },
    fetchPromise
  );
};


// WEBPACK FOOTER //
// ./src/redux/homeActions.js